import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Group } from '../../clients/aasServerClient.generated';
import { getAssignablePrivileges } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import FormInput from '../common/FormInput';

interface Props extends LocalizeContextProps {
    type: 'edit' | 'new';
    group: Partial<Group>;
    updateGroup: (group: Partial<Group>) => void;
}

class GroupProperties extends React.Component<Props, Partial<Group>> {

    public constructor(props: Props) {
        super(props);
        this.state = props.group;
        this.props.updateGroup(this.state);
    }

    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                <FormInput
                    row={true}
                    name="name"
                    fullName={t('groups.edit.field.name') as string}
                    value={this.state.name || ''}
                    onChange={this.handleGroupChange}
                />
            </React.Fragment>
        );
    }

    private handleGroupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const update = {
            [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        };
        this.setState(update);
        this.props.updateGroup({ ...this.state, ...update });
    }
}

const mapStateToProps = (state: RootState) => ({
});

export default connect(mapStateToProps)(withLocalize(GroupProperties));